import resourceList from '../resource_list';
import rest from '../rest';

async function createMerchantEnquiry(postData) {
  return rest.post(resourceList.REWARD, '/merchant/enquiry/create', postData);
}

export default createMerchantEnquiry;
